<template>
    <div>
        <div class="d-sm-block d-mb-block d-lg-none" v-if="isMobile">
            <div class="main-container-mobile">
                <div class="first-container-mobile">
                    <div class="first-block">
                        <div class="logo-container-footer">
                            <img src="../assets/img/beefeater-footer-logo.svg" alt="logo" class="jameson-logo-mobile" />
                        </div>
                        <!-- <img :src="config.logoMain" alt="logo" class="jameson-logo" /> -->
                        <!-- <img :src="config.logoInvisible" alt="jameson" class="jameson-invisible" /> -->
                        <p class="title-first-block-mobile">
                            <span v-for="(line, i) in config.title" :key="i">
                                {{ line }}
                                <br v-if="i < config.title.length - 1">
                            </span>
                        </p>
                        <p class="description-first-block-mobile">
                            <!-- <span v-for="(line, i) in config.description" :key="i">
                                {{ line }}
                                <br v-if="i < config.description.length - 1">
                            </span> -->
                        </p>
                        <div class="logo-container-footer">
                            <img src="../assets/img/beefeater-first-block-img-mobile.png" alt="logo"
                                class="big-img-first-block-mobile" />
                        </div>
                        <!-- <p class="description-first-block-small-mobile"> -->
                            <!-- <span v-for="(line, i) in config.smallDescrtiption" :key="i">
                                {{ line }}
                                <br v-if="i < config.smallDescrtiption.length - 1">
                            </span> -->
                        <!-- </p> -->
                    </div>
                    <!-- <div class="second-block">
                                <img :src="config.bigImage" alt="jameson" class="big-img-first-block" />
                            </div> -->
                </div>

                <div class="second-contaier second-contaier-mobile"
                    :style="{ '--bg-url': `url(${require('@/assets' + config.bgImageSecondMobile)})` }">
                    <div class="second-first-container-mobile">
                        <div class="second-first-block-mobile">
                            <p class="second-block-title-mobile">{{ config.titleCond }}</p>
                            <!-- <p class="second-block-description-mobile">
                                <span>{{ config.secondTitleCond }}</span>
                            </p> -->
                        </div>
                        <div class="second-second-block-mobile">
                            <div v-for="(cond, index) in config.conditions" :key="index"
                                class="d-flex flex-row align-items-center condition-container">
                                <p class="number-mobile">{{ index + 1 }}.</p>
                                <p class="condition-text-mobile"><span v-html="cond"></span></p>
                            </div>
                            <!-- <div class="d-flex flex-row align-items-center condition-container">
                                <p class="number">1.</p>
                                <p class="condition-text"><span>Подпишись</span>
                                    <span>на наш аккаунт</span>
                                </p>

                            </div>
                            <div class="d-flex flex-row align-items-center condition-container">
                                <p class="number">2.</p>
                                <p class="condition-text">
                                    <span>Сделай репост этой публикации себе в сторис или ленту</span>
                                    <span> с отметкой нашего аккаунта.</span>
                                </p>


                            </div>
                            <div class="d-flex flex-row align-items-center condition-container">
                                <p class="number">3.</p>
                                <p class="condition-text">
                                    <span>В комментариях под постом отметь двух друзей, с</span>
                                    <span>кем пошёл(а) бы на вечеринку.</span>
                                </p>

                            </div>
                            <div class="d-flex flex-row align-items-center condition-container">
                                <p class="number">4.</p>
                                <p class="condition-text"><span>Заполни короткую форму по ссылке в профиле.</span></p>
                            </div> -->
                        </div>

                    </div>
                </div>

                <div class="third-container-mobile">
                    <!-- <img src="@/assets/img/jameson-form-bg-mobile-left.png" alt="Background" class="background-image-mobile-topleft" />
                <img src="@/assets/img/jameson-form-bg-mobile-right.png" alt="Background" class="background-image-mobile-topright" /> -->
                    <div class="registration-body-container-mobile">
                        <!-- <div class="title-container">
                            <p class="text-title-mobile">Зарегистрируйся!</p>
                        </div> -->
                        <div v-if="isLoadingForm" class="form-loading">
                            <v-progress-circular indeterminate size="64" color="#141097" />
                        </div>
                        <div v-else-if="formError" class="form-error">
                            <p class="form-error-text">Ошибка загрузки формы. Попробуйте позже.</p>
                            <button class="btn-form-submit mt-10 mb-10" @click="getFormFields">Повторить
                                попытку</button>
                        </div>
                        <div v-else class="form-main-mobile">
                            <div v-for="question in normalQuestions" :key="question.id" class="form-container">
                                <!-- input text/email/etc -->
                                <div>
                                    <input v-if="[1, 2, 7, 10].includes(question.type)" class="input-body-mobile"
                                        v-model="formData[question.id]" :placeholder="question.name"
                                        @blur="markTouched(question)" @input="validateField(question)" />
                                    <input v-else-if="question.type === 4" class="input-body-mobile"
                                        v-model="formData[question.id]" v-mask="'+7(###) ###-##-##'"
                                        placeholder="+7 (___) ___-__-__" @blur="markTouched(question)"
                                        @input="validateField(question)" />
                                    <div class="error-message">
                                        <span v-show="errors[question.id]">{{ errors[question.id] }}</span>
                                    </div>
                                </div>
                                <!-- select -->
                                <v-select v-if="[5, 9, 6].includes(question.type)" v-model="formData[question.id]"
                                    :items="question.answers" item-text="name" item-value="id" dense outlined
                                    hide-details :placeholder="question.name" class="mb-3 pt-1">
                                    <template v-slot:selection="{ item }">
                                        <div v-if="item" style="white-space: normal; word-break: break-word;">
                                            {{ item.name }}
                                        </div>
                                        <span v-else class="truncate-text">
                                            {{ getPlaceholder(question) }}
                                        </span>
                                    </template>
                                </v-select>
                            </div>
                            <div class="btn-container mt-6">
                                <div v-for="question in filteredQuestions" :key="question.id"
                                    class="checkbox-container">

                                    <div class="checkbox-content">
                                        <input class="custom-checkbox" type="checkbox" v-model="formData[question.id]"
                                            :id="question.id" @change="markTouched(question)"
                                            @input="validateField(question)" />

                                        <label class="checkbox-label" :for="question.id" style="color: black;">
                                            <!-- если это согласие на обработку персональных данных -->
                                            <template v-if="question.number === 7">
                                                Я даю согласие на
                                                <a style="color: black; text-decoration: underline;"
                                                    @click.stop.prevent="openPopup('offer')">
                                                    сбор и обработку персональных данных
                                                </a>
                                            </template>

                                            <!-- для всех остальных чекбоксов -->
                                            <template v-else>
                                                {{ question.name }}
                                            </template>
                                        </label>
                                    </div>

                                </div>
                                <button @click="confirmRegistration"
                                    class="btn-form-submit-mobile mt-10 mb-10"
                                    :disabled="isSendSms"
                                    >{{ isSendSms ? "Отправка..." : "Принять участие" }}</button>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="main-container-footer-mobile">


                    <div class="footer-container-mobile">
                        <div class="politics-container-mobile">
                            <div class="logo-container-footer">
                                <img src="../assets/img/beefeater-footer-logo.svg" alt="" class="jameson-logo-footer-mobile" />
                            </div>
                            <div class="d-flex flex-column">
                                <div class="footer-first-block">
                                    <p class="link-text-mobile pb-5">{{ config.footer.warningText }}</p>
                                    <a class="link-text-mobile" style="text-decoration: underline;"
                                        :href="config.footer.policyLink.href" target="_blank">
                                        {{ config.footer.policyLink.text }}
                                    </a>
                                </div>
                                <!-- <div class="logo-container-footer-2">
                                    <img src="../assets/img/j-invicible.png" alt="logo" class="j-logo-footer" />
                                </div> -->
                                <div class="footer-second-block">
                                    <p v-for="(item, index) in config.footer.menuLinks" :key="index"
                                        class="footer-main-text">
                                        <a class="footer-main-text" @click="openPopup(item.href)">{{ item.text }}</a>
                                    </p>
                                </div>
                            </div>

                        </div>
                        <div class="social-container-mobile">
                            <div class="footer-j-logo">
                                <!-- <img :src="config.footer.logo" class="j-logo-footer" alt="j-logo"> -->
                            </div>
                            <div class="social-icons-container">
                                <div @click="goTo(' https://www.instagram.com/beefeaterkz/')">
                                    <svg width="51" height="51" viewBox="0 0 51 51" fill="#CD122D"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="25.8242" cy="25.8315" r="25" fill="#FFFFFF" />
                                        <path
                                            d="M36.3973 21.1698C36.3467 20.0215 36.161 19.232 35.895 18.548C35.6206 17.8218 35.1984 17.1717 34.6452 16.6313C34.1048 16.0825 33.4504 15.656 32.7327 15.3859C32.0447 15.1199 31.2593 14.9342 30.111 14.8835C28.9541 14.8286 28.5869 14.8159 25.6527 14.8159C22.7185 14.8159 22.3512 14.8286 21.1986 14.8792C20.0503 14.9299 19.2609 15.1157 18.5769 15.3816C17.8507 15.656 17.2006 16.0782 16.6601 16.6313C16.1113 17.1717 15.685 17.8261 15.4147 18.5439C15.1487 19.232 14.963 20.0172 14.9123 21.1655C14.8574 22.3224 14.8447 22.6897 14.8447 25.6239C14.8447 28.5581 14.8574 28.9253 14.9081 30.0779C14.9587 31.2263 15.1445 32.0157 15.4106 32.6998C15.685 33.4259 16.1113 34.076 16.6601 34.6164C17.2006 35.1653 17.8549 35.5918 18.5727 35.8619C19.2609 36.1279 20.046 36.3136 21.1945 36.3642C22.3469 36.415 22.7144 36.4276 25.6486 36.4276C28.5828 36.4276 28.95 36.415 30.1026 36.3642C31.2509 36.3136 32.0404 36.1279 32.7243 35.8619C34.1767 35.3003 35.325 34.152 35.8866 32.6998C36.1524 32.0116 36.3383 31.2263 36.3889 30.0779C36.4395 28.9253 36.4522 28.5581 36.4522 25.6239C36.4522 22.6897 36.4479 22.3224 36.3973 21.1698ZM34.4511 29.9935C34.4046 31.049 34.2273 31.6189 34.0796 31.9989C33.7164 32.9404 32.9692 33.6876 32.0277 34.0508C31.6477 34.1985 31.0736 34.3758 30.0223 34.4222C28.8824 34.473 28.5405 34.4855 25.657 34.4855C22.7734 34.4855 22.4272 34.473 21.2915 34.4222C20.236 34.3758 19.6661 34.1985 19.2861 34.0508C18.8176 33.8776 18.3911 33.6032 18.0449 33.2443C17.6861 32.8939 17.4116 32.4717 17.2385 32.0032C17.0907 31.6232 16.9134 31.049 16.8671 29.9978C16.8163 28.8579 16.8038 28.5159 16.8038 25.6323C16.8038 22.7487 16.8163 22.4026 16.8671 21.267C16.9134 20.2115 17.0907 19.6415 17.2385 19.2616C17.4116 18.7929 17.6861 18.3666 18.0492 18.0202C18.3995 17.6614 18.8217 17.387 19.2904 17.214C19.6703 17.0662 20.2446 16.8889 21.2958 16.8424C22.4357 16.7918 22.7777 16.7791 25.6611 16.7791C28.5489 16.7791 28.8908 16.7918 30.0266 16.8424C31.0821 16.8889 31.652 17.0662 32.032 17.214C32.5005 17.387 32.927 17.6614 33.2731 18.0202C33.632 18.3707 33.9064 18.7929 34.0796 19.2616C34.2273 19.6415 34.4046 20.2156 34.4511 21.267C34.5018 22.4069 34.5145 22.7487 34.5145 25.6323C34.5145 28.5159 34.5018 28.8536 34.4511 29.9935Z"
                                            fill="#CD122D" />
                                        <path
                                            d="M25.6543 20.0715C22.5893 20.0715 20.1025 22.5581 20.1025 25.6233C20.1025 28.6884 22.5893 31.175 25.6543 31.175C28.7194 31.175 31.206 28.6884 31.206 25.6233C31.206 22.5581 28.7194 20.0715 25.6543 20.0715ZM25.6543 29.2246C23.6659 29.2246 22.053 27.6118 22.053 25.6233C22.053 23.6347 23.6659 22.022 25.6543 22.022C27.6428 22.022 29.2556 23.6347 29.2556 25.6233C29.2556 27.6118 27.6428 29.2246 25.6543 29.2246Z"
                                            fill="#CD122D" />
                                        <path
                                            d="M32.7222 19.8522C32.7222 20.568 32.1419 21.1483 31.426 21.1483C30.7102 21.1483 30.1299 20.568 30.1299 19.8522C30.1299 19.1363 30.7102 18.5562 31.426 18.5562C32.1419 18.5562 32.7222 19.1363 32.7222 19.8522Z"
                                            fill="#CD122D" />
                                    </svg>
                                </div>
                                <!-- <div @click="goTo('https://www.youtube.com/')">
                                    <svg width="51" height="51" viewBox="0 0 51 51" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="25.8242" cy="25.8315" r="25" fill="#FFFFFF" />
                                        <path
                                            d="M36.7156 24.4729C36.7156 23.9881 36.6348 23.4225 36.6348 22.776C36.554 22.1295 36.4732 21.4831 36.3924 20.9174C36.2308 20.2709 35.9884 19.7861 35.5035 19.3821C35.0995 18.978 34.5338 18.7356 33.9682 18.6548C32.1096 18.4123 29.3621 18.3315 25.6449 18.3315C21.9278 18.3315 19.0995 18.4123 17.3217 18.6548C16.756 18.7356 16.1904 18.978 15.7863 19.3821C15.3823 19.7861 15.0591 20.2709 14.8974 20.9174C14.7358 21.4831 14.655 22.0487 14.655 22.776C14.5742 23.4225 14.5742 23.9881 14.5742 24.4729C14.5742 24.9578 14.5742 25.5235 14.5742 26.3315C14.5742 27.1396 14.5742 27.7861 14.5742 28.1901C14.5742 28.675 14.655 29.2406 14.655 29.8871C14.7358 30.5336 14.8166 31.18 14.8974 31.7457C15.0591 32.3921 15.3015 32.877 15.7863 33.281C16.1904 33.6851 16.756 33.9275 17.3217 34.0083C19.1803 34.2507 21.9278 34.3315 25.6449 34.3315C29.3621 34.3315 32.1904 34.2507 33.9682 34.0083C34.5338 33.9275 35.0995 33.6851 35.5035 33.281C35.9075 32.877 36.2308 32.3921 36.3924 31.7457C36.554 31.18 36.6348 30.6144 36.6348 29.8871C36.7156 29.2406 36.7156 28.675 36.7156 28.1901C36.7156 27.7053 36.7156 27.1396 36.7156 26.3315C36.7156 25.5235 36.7156 24.877 36.7156 24.4729ZM29.9278 26.978L23.5439 30.9376C23.4631 31.0184 23.3015 31.0992 23.1399 31.0992C22.9783 31.0992 22.8975 31.0992 22.7358 31.0184C22.4934 30.8568 22.3318 30.6144 22.3318 30.2911V22.2911C22.3318 21.9679 22.4934 21.7255 22.7358 21.5639C22.9783 21.4023 23.3015 21.4023 23.5439 21.5639L29.9278 25.5235C30.1702 25.6851 30.3318 25.9275 30.3318 26.1699C30.3318 26.4123 30.1702 26.8164 29.9278 26.978Z"
                                            fill="#000000" />
                                    </svg>
                                </div> -->
                            </div>


                        </div>
                    </div>

                </div>
            </div>
            <otp :showPopup="showOtpPopup" :smsTimer="smsTimer" :errorSms="otpErrorSms" @resend="resendSms" @verifyCode="submitAnswersWithCode"
                @closePopup="showOtpPopup = false" :success="otpSuccess" :errorMessage="otpError"
                :loading="otpVerifying" />
        </div>
        <div class="d-none d-lg-block d-xl-block d-xxl-block" v-else>
            <div class="main-container">
                <div class="first-container">
                    <div class="first-block">
                        <!-- <img src="../assets/img/jameson-logo-age-confirm.png" alt="logo" class="jameson-logo" /> -->
                        <img src="../assets/img/beefeater-age-confirm-logo.svg" alt="logo" class="jameson-logo" />
                        <!-- <img :src="config.logoMain" alt="logo" class="jameson-logo" /> -->
                        <!-- <img :src="config.logoInvisible" alt="jameson" class="jameson-invisible" /> -->
                        <!-- <img src="../assets/img/j-invicible.png" alt="logo" class="jameson-invisible" /> -->
                        <p class="title-first-block">
                            <span v-for="(line, i) in config.title" :key="i">
                                {{ line }}
                                <br v-if="i < config.title.length - 1">
                            </span>
                        </p>
                        <p class="description-first-block">
                            <!-- <span v-for="(line, i) in config.description" :key="i" :class="{ 'with-padding': i === 2 }">
                                {{ line }}
                                <br v-if="i < config.description.length - 1">
                            </span> -->

                        </p>
                        <p class="description-first-block-small">
                            <!-- <span v-for="(line, i) in config.smallDescrtiption" :key="i">
                                {{ line }}
                                <br v-if="i < config.smallDescrtiption.length - 1">
                            </span> -->
                        </p>
                    </div>
                    <!-- <div class="second-block">
                        <img src="../assets/img/test.png" alt="logo" class="big-img-first-block" />
                       
                    </div> -->
                </div>

                <div class="second-contaier"
                    :style="{ '--bg-url': `url(${require('@/assets' + config.bgImageSecond)})` }">
                    <div class="second-first-container">
                        <div class="second-first-block">
                            <p class="second-block-title">{{ config.titleCond }}</p>
                            <!-- <p class="second-block-description">
                                <span>{{ config.secondTitleCond }}</span>
                            </p> -->
                        </div>
                        <div class="second-second-block">
                            <div v-for="(cond, index) in config.conditions" :key="index"
                                class="d-flex flex-row align-items-center condition-container">
                                <p class="number">{{ index + 1 }}.</p>
                                <p class="condition-text"><span v-html="cond"></span></p>
                            </div>

                        </div>

                    </div>
                </div>

                <div class="third-container">
                    <!-- <img src="@/assets/img/jameson-form-bg-left.png" alt="Background" class="background-image-mobile-topleft" />
                    <img src="@/assets/img/jameson-form-bg-right.png" alt="Background" class="background-image-mobile-topright" /> -->
                    <div class="registration-body-container">
                        <div class="title-container">
                            <!-- <p class="text-title">Зарегистрируйся!</p>
                            <p style="color: white">Возраст: {{ getUserAge || 'Нет данных' }}</p> -->
                        </div>
                        <div v-if="isLoadingForm" class="form-loading">
                            <v-progress-circular indeterminate size="64" color="#CD122D" />
                        </div>
                        <div v-else-if="formError" class="form-error">
                            <p class="form-error-text">Ошибка загрузки формы. Попробуйте позже.</p>
                            <button class="btn-form-submit mt-10 mb-10" @click="getFormFields">Повторить
                                попытку</button>
                        </div>
                        <div v-else class="form-main">
                            <div v-for="question in normalQuestions" :key="question.id" class="form-container">
                                <!-- input text/email/etc -->
                                <div>
                                    <input v-if="[1, 2, 7, 10].includes(question.type)" class="input-body"
                                        v-model="formData[question.id]" :placeholder="getPlaceholder(question)"
                                        @blur="markTouched(question)" @input="validateField(question)" />
                                    <input v-else-if="question.type === 4" class="input-body"
                                        v-model="formData[question.id]" v-mask="'+7(###) ###-##-##'"
                                        placeholder="+7 (___) ___-__-__" @blur="markTouched(question)"
                                        @focus="onPhoneFocus(question)" @input="onPhoneInput(question)" />
                                    <div class="error-message">
                                        <span v-show="errors[question.id]">{{ errors[question.id] }}</span>
                                    </div>
                                </div>
                                <!-- select -->
                                <v-select v-if="[5, 9, 6].includes(question.type)" v-model="formData[question.id]"
                                    :items="question.answers" item-text="name" item-value="id" dense outlined
                                    hide-details :placeholder="getPlaceholder(question)" class="my-select mb-4">
                                    <template v-slot:selection="{ item }">
                                        <div class="select-input" style="white-space: normal; word-break: break-word;">
                                            {{ item.name }}
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                        <div v-if="!formError" class="btn-container mt-6 mb-5">
                            <div v-for="question in filteredQuestions" :key="question.id" class="checkbox-container">

                                <div class="checkbox-content">
                                    <input class="custom-checkbox" type="checkbox" v-model="formData[question.id]"
                                        :id="question.id" @change="markTouched(question)"
                                        @input="validateField(question)" />

                                    <label class="checkbox-label" :for="question.id" style="color: black;">
                                        <!-- если это согласие на обработку персональных данных -->
                                        <template v-if="question.number === 7">
                                            Я даю согласие на
                                            <a style="color: black; text-decoration: underline;"
                                                @click.stop.prevent="openPopup('offer')">
                                                сбор и обработку персональных данных
                                            </a>
                                        </template>

                                        <!-- для всех остальных чекбоксов -->
                                        <template v-else>
                                            {{ question.name }}
                                        </template>
                                    </label>
                                </div>
                            </div>
                            <!-- <div class="checkbox-container" v-if="consentQuestion">
                                    <input class="checkbox" type="checkbox" :id="consentQuestion.id"
                                        v-model="answers[consentQuestion.id]"
                                        :name="consentQuestion.id"
                                        checked />
                                    <label :for="consentQuestion.id">Я даю согласие на <a
                                            style="color: white;text-decoration:underline;"
                                            @click="openPopup('offer')">сбор и обратботку
                                            персональных
                                            данных</a></label>
                                </div> -->
                            <button @click="confirmRegistration"
                                class="btn-form-submit mt-10 mb-10"
                                :disabled="isSendSms"
                                >{{ isSendSms ? "Отправка..." : "Принять участие" }}</button>

                        </div>
                    </div>

                </div>
                <div class="main-container-footer">


                    <div class="footer-container">
                        <div class="politics-container">
                            <div>
                                <img src="../assets/img/beefeater-age-confirm-logo.svg" alt="" class="jameson-logo-footer" />
                            </div>
                            <div class="d-flex">
                                <div class="footer-first-block">
                                    <p class="link-text pb-5">{{ config.footer.warningText }}</p>
                                    <a class="link-text" style="text-decoration: underline;"
                                        :href="config.footer.policyLink.href" target="_blank">
                                        {{ config.footer.policyLink.text }}
                                    </a>
                                </div>
                                <div class="footer-second-block">
                                    <p v-for="(item, index) in config.footer.menuLinks" :key="index"
                                        class="footer-main-text">
                                        <a class="footer-main-text" @click="openPopup(item.href)">{{ item.text
                                            }}</a>
                                    </p>
                                </div>
                            </div>
                            <!-- <button @click="openPopup('policy')">Политика конфиденциальности</button>
                            <button @click="openPopup('offer')">Оферта</button>
                            <button @click="openPopup('rules')">Правила</button> -->
                        </div>
                        <div class="social-container">
                            <div class="footer-j-logo">
                                <!-- <img :src="config.footer.logo" class="j-logo-footer" alt="j-logo">
                                    <img src="../assets/img/j-invicible.png" alt="logo" class="j-logo-footer" /> -->
                            </div>
                            <div class="social-icons-container">
                                <!-- <div class="" @click="goTo('https://www.facebook.com/ChivasRegalKazakhstan')">
                                    <svg width="51" height="51" viewBox="0 0 51 51" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="25.8242" cy="25.8315" r="25" fill="#F2E4B5" />
                                        <path
                                            d="M37.0742 18.1049C37.0742 16.2331 35.4227 14.5815 33.5509 14.5815H19.3475C17.4758 14.5815 15.8242 16.2331 15.8242 18.1049V32.3082C15.8242 34.18 17.4758 35.8315 19.3475 35.8315H26.5043V27.794H23.8618V24.2707H26.5043V22.8393C26.5043 20.417 28.2659 18.3251 30.468 18.3251H33.3307V21.8484H30.468C30.1377 21.8484 29.8074 22.1787 29.8074 22.8393V24.2707H33.3307V27.794H29.8074V35.8315H33.5509C35.4227 35.8315 37.0742 34.18 37.0742 32.3082V18.1049Z"
                                            fill="#000000" />
                                    </svg>
                                </div> -->
                                <div @click="goTo('https://www.instagram.com/beefeaterkz')">
                                    <svg width="51" height="51" viewBox="0 0 51 51" fill="#CD122D"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="25.8242" cy="25.8315" r="25" fill="#FFFFFF" />
                                        <path
                                            d="M36.3973 21.1698C36.3467 20.0215 36.161 19.232 35.895 18.548C35.6206 17.8218 35.1984 17.1717 34.6452 16.6313C34.1048 16.0825 33.4504 15.656 32.7327 15.3859C32.0447 15.1199 31.2593 14.9342 30.111 14.8835C28.9541 14.8286 28.5869 14.8159 25.6527 14.8159C22.7185 14.8159 22.3512 14.8286 21.1986 14.8792C20.0503 14.9299 19.2609 15.1157 18.5769 15.3816C17.8507 15.656 17.2006 16.0782 16.6601 16.6313C16.1113 17.1717 15.685 17.8261 15.4147 18.5439C15.1487 19.232 14.963 20.0172 14.9123 21.1655C14.8574 22.3224 14.8447 22.6897 14.8447 25.6239C14.8447 28.5581 14.8574 28.9253 14.9081 30.0779C14.9587 31.2263 15.1445 32.0157 15.4106 32.6998C15.685 33.4259 16.1113 34.076 16.6601 34.6164C17.2006 35.1653 17.8549 35.5918 18.5727 35.8619C19.2609 36.1279 20.046 36.3136 21.1945 36.3642C22.3469 36.415 22.7144 36.4276 25.6486 36.4276C28.5828 36.4276 28.95 36.415 30.1026 36.3642C31.2509 36.3136 32.0404 36.1279 32.7243 35.8619C34.1767 35.3003 35.325 34.152 35.8866 32.6998C36.1524 32.0116 36.3383 31.2263 36.3889 30.0779C36.4395 28.9253 36.4522 28.5581 36.4522 25.6239C36.4522 22.6897 36.4479 22.3224 36.3973 21.1698ZM34.4511 29.9935C34.4046 31.049 34.2273 31.6189 34.0796 31.9989C33.7164 32.9404 32.9692 33.6876 32.0277 34.0508C31.6477 34.1985 31.0736 34.3758 30.0223 34.4222C28.8824 34.473 28.5405 34.4855 25.657 34.4855C22.7734 34.4855 22.4272 34.473 21.2915 34.4222C20.236 34.3758 19.6661 34.1985 19.2861 34.0508C18.8176 33.8776 18.3911 33.6032 18.0449 33.2443C17.6861 32.8939 17.4116 32.4717 17.2385 32.0032C17.0907 31.6232 16.9134 31.049 16.8671 29.9978C16.8163 28.8579 16.8038 28.5159 16.8038 25.6323C16.8038 22.7487 16.8163 22.4026 16.8671 21.267C16.9134 20.2115 17.0907 19.6415 17.2385 19.2616C17.4116 18.7929 17.6861 18.3666 18.0492 18.0202C18.3995 17.6614 18.8217 17.387 19.2904 17.214C19.6703 17.0662 20.2446 16.8889 21.2958 16.8424C22.4357 16.7918 22.7777 16.7791 25.6611 16.7791C28.5489 16.7791 28.8908 16.7918 30.0266 16.8424C31.0821 16.8889 31.652 17.0662 32.032 17.214C32.5005 17.387 32.927 17.6614 33.2731 18.0202C33.632 18.3707 33.9064 18.7929 34.0796 19.2616C34.2273 19.6415 34.4046 20.2156 34.4511 21.267C34.5018 22.4069 34.5145 22.7487 34.5145 25.6323C34.5145 28.5159 34.5018 28.8536 34.4511 29.9935Z"
                                            fill="#CD122D" />
                                        <path
                                            d="M25.6543 20.0715C22.5893 20.0715 20.1025 22.5581 20.1025 25.6233C20.1025 28.6884 22.5893 31.175 25.6543 31.175C28.7194 31.175 31.206 28.6884 31.206 25.6233C31.206 22.5581 28.7194 20.0715 25.6543 20.0715ZM25.6543 29.2246C23.6659 29.2246 22.053 27.6118 22.053 25.6233C22.053 23.6347 23.6659 22.022 25.6543 22.022C27.6428 22.022 29.2556 23.6347 29.2556 25.6233C29.2556 27.6118 27.6428 29.2246 25.6543 29.2246Z"
                                            fill="#CD122D" />
                                        <path
                                            d="M32.7222 19.8522C32.7222 20.568 32.1419 21.1483 31.426 21.1483C30.7102 21.1483 30.1299 20.568 30.1299 19.8522C30.1299 19.1363 30.7102 18.5562 31.426 18.5562C32.1419 18.5562 32.7222 19.1363 32.7222 19.8522Z"
                                            fill="#CD122D" />
                                    </svg>
                                </div>
                                <!-- <div @click="goTo('https://www.youtube.com/')">
                                    <svg width="51" height="51" viewBox="0 0 51 51" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="25.8242" cy="25.8315" r="25" fill="#FFFFFF" />
                                        <path
                                            d="M36.7156 24.4729C36.7156 23.9881 36.6348 23.4225 36.6348 22.776C36.554 22.1295 36.4732 21.4831 36.3924 20.9174C36.2308 20.2709 35.9884 19.7861 35.5035 19.3821C35.0995 18.978 34.5338 18.7356 33.9682 18.6548C32.1096 18.4123 29.3621 18.3315 25.6449 18.3315C21.9278 18.3315 19.0995 18.4123 17.3217 18.6548C16.756 18.7356 16.1904 18.978 15.7863 19.3821C15.3823 19.7861 15.0591 20.2709 14.8974 20.9174C14.7358 21.4831 14.655 22.0487 14.655 22.776C14.5742 23.4225 14.5742 23.9881 14.5742 24.4729C14.5742 24.9578 14.5742 25.5235 14.5742 26.3315C14.5742 27.1396 14.5742 27.7861 14.5742 28.1901C14.5742 28.675 14.655 29.2406 14.655 29.8871C14.7358 30.5336 14.8166 31.18 14.8974 31.7457C15.0591 32.3921 15.3015 32.877 15.7863 33.281C16.1904 33.6851 16.756 33.9275 17.3217 34.0083C19.1803 34.2507 21.9278 34.3315 25.6449 34.3315C29.3621 34.3315 32.1904 34.2507 33.9682 34.0083C34.5338 33.9275 35.0995 33.6851 35.5035 33.281C35.9075 32.877 36.2308 32.3921 36.3924 31.7457C36.554 31.18 36.6348 30.6144 36.6348 29.8871C36.7156 29.2406 36.7156 28.675 36.7156 28.1901C36.7156 27.7053 36.7156 27.1396 36.7156 26.3315C36.7156 25.5235 36.7156 24.877 36.7156 24.4729ZM29.9278 26.978L23.5439 30.9376C23.4631 31.0184 23.3015 31.0992 23.1399 31.0992C22.9783 31.0992 22.8975 31.0992 22.7358 31.0184C22.4934 30.8568 22.3318 30.6144 22.3318 30.2911V22.2911C22.3318 21.9679 22.4934 21.7255 22.7358 21.5639C22.9783 21.4023 23.3015 21.4023 23.5439 21.5639L29.9278 25.5235C30.1702 25.6851 30.3318 25.9275 30.3318 26.1699C30.3318 26.4123 30.1702 26.8164 29.9278 26.978Z"
                                            fill="#000000" />
                                    </svg>
                                </div> -->
                            </div>


                        </div>
                    </div>

                </div>
                <otp :showPopup="showOtpPopup" :smsTimer="smsTimer" :errorSms="otpErrorSms" @resend="resendSms"
                    @verifyCode="submitAnswersWithCode" @closePopup="showOtpPopup = false" :success="otpSuccess"
                    :errorMessage="otpError" :loading="otpVerifying" />

            </div>


        </div>
        <ConfirmAge1 v-if="showConfirm" @confirmed="onConfirmed" />
        <transition name="popup">
            <div v-if="isPopupOpen" class="popup-overlay" @click.self="closePopup">
                <div class="popup-content">
                    <div class="popup-header">
                        <span class="header-text">{{ popupTexts[currentPopup].title }}</span>
                        <span class="popup-close-1" @click="closePopup"><svg width="21" height="21" viewBox="0 0 40 40"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M1.07373 33.4784C-0.348236 34.8712 -0.377256 37.4247 1.10275 38.9046C2.58275 40.3845 5.13648 40.3264 6.52942 38.9336L19.9945 25.4697L33.4597 38.9046C34.9106 40.3555 37.4063 40.3845 38.8863 38.8756C40.3663 37.3957 40.3663 34.9003 38.9154 33.4494L25.4793 20.0145L38.9154 6.5506C40.3663 5.09975 40.3663 2.60428 38.8863 1.12441C37.4063 -0.384476 34.9106 -0.355459 33.4597 1.09539L19.9945 14.5303L6.52942 1.06638C5.13648 -0.326442 2.58275 -0.384476 1.10275 1.09539C-0.377256 2.57526 -0.348236 5.12876 1.07373 6.5506L14.5388 20.0145L1.07373 33.4784Z"
                                    fill="white" />
                            </svg></span>
                    </div>
                    <div class="popup-text-1" v-html="popupTexts[currentPopup].content"></div>
                </div>
            </div>
        </transition>

        <v-snackbar v-model="snackbar" timeout="3000" class="btn-contaiener">
            {{ message }}
            <template v-slot:action="{ attrs }">
                <div class="snackbar-btn" text v-bind="attrs" @click="snackbar = false">
                    Закрыть
                </div>
            </template>
        </v-snackbar>
    </div>


</template>


<style scoped>
.with-padding {
    display: block;
    /* чтобы padding сработал корректно */
    margin-top: 25px;
}

.background-image-mobile-topright {
    position: absolute;
    top: -1px;
    right: 0;
    height: auto;
    /* width: 20%; */
    object-fit: cover;
    z-index: 1;
}

.background-image-mobile-topleft {
    position: absolute;
    top: -1px;
    left: 0;
    height: auto;
    /* width: 20%; */
    object-fit: cover;
    z-index: 1;
}

::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
    padding: 4px 5px;
    color: var(--color-black);
    font-size: 24px;
    font-family: var(--font-family);
}

.third-container ::v-deep .v-select input::placeholder {
    color: var(--color-black) !important;
    font-weight: 400;
    font-size: 24px;
}

.third-container ::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot {
    padding: 0 12px;
    width: 499px !important;
    min-height: 52px;
}

.third-container ::v-deep .v-list-item--dense .v-list-item__title {
    font-size: 24px !important;
}

input:focus {
    outline: 1px solid #1976d2;
    /* синяя обводка */
    /* или */
    box-shadow: 0 0 5px #1976d2;
}

.third-container ::v-deep .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot fieldset {
    color: var(--color-black) !important;
    border-radius: 6.64px;
}

.third-container ::v-deep .v-select.v-input--dense .v-select__selection--comma {
    margin: 0;
    font-size: 24px;
}

.third-container ::v-deep .v-input__slot {
    align-items: center;
    display: flex;
    margin-bottom: 8px;
    min-height: inherit;
    position: relative;
    transition: .3s cubic-bezier(.25, .8, .5, 1);
    transition-property: height, min-height;
    /* width: 461px; */
}

.third-container ::v-deep .v-input {
    align-items: flex-start;
    display: flex;
    flex: none;
    font-size: 16px;
    letter-spacing: normal;
    max-width: 100%;
    text-align: left;
    /* height: 48px; */
}

.popup-header {
    padding: 10px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.popup-content {
    background-color: var(--color-primary-popup);
    background-size: cover;
    background-position: center;
    padding: 20px;
    width: 100%;
    max-width: 1150px;
    border-radius: 10px;
    /* max-height: 897px; */
    height: 100%;
    max-height: 80vh;
    /* ограничение всей области */
    display: flex;
    flex-direction: column;

}

:deep(.chivas-link) {
    color: var(--color-white);
    /* font-weight: bold; */
    text-decoration: underline;
    transition: color 0.2s;
}

:deep(.chivas-link:hover) {
    color: var(--color-primary);
    text-decoration: underline;
}

.condition-container {
    border-top: 2px solid var(--color-white);
    /* border-bottom: 2px solid #141097; */
}

.second-second-block .condition-container:last-child {
    border-bottom: 2px solid var(--color-white);
}

/* .second-second-block .condition-container:nth-child(-n+3) {
    border-bottom: none;
} */


.condition-text {
    margin-bottom: 0px;
    display: flex;
    flex-direction: column;
    line-height: 1.1;
    margin-left: 39.4px;
    font-family: var(--font-family);
}

.condition-text span {
    font-weight: 500;
    font-size: 32px;
    color: var(--color-white);
    margin-bottom: 0px;
    font-family: var(--font-family);
    text-decoration: none;
}

.second-second-block-mobile .condition-container:nth-child(-n+3) {
    border-bottom: none;
}

.error-message {
    color: red;
    font-weight: 300;
    font-size: 14px;
    font-family: var(--font-family);
    min-height: 18px;
}

.form-main-mobile {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 18px;
    max-width: 666px;


}

.form-loading {
    display: flex;
    justify-content: center;
    align-items: center;
}

.form-error {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.form-error-text {
    font-weight: 400;
    font-size: 16px;
    color: #ad0202;
    margin-bottom: 0px;
    font-family: var(--font-family);
}

.registration-body-container-mobile {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* border-radius: 20px; */
    padding: 0px 33.33px 0px;
    /* max-width: 1033px;
    min-width: 320px; */
    height: 100%;
    /* background: #f2e4b5; */
    margin: auto;
}



.btn-form-submit,
.btn-form-submit-mobile {
    border-radius: 10px;
    padding: 11px 42px;
    height: 59px;
    background: var(--color-primary);
    font-family: var(--font-family);
    font-weight: 500;
    font-size: var(--font-size-md);
    color: var(--color-white);
    cursor: pointer;
    box-shadow: 0 4px 0 #b80923;

    /* медленный возврат */
    transition: all 0.4s ease;
}

/* При наведении (быстрее, чем возврат) */
.btn-form-submit:hover,
.btn-form-submit-mobile:hover {
    background: var(--color-primary);
    transform: translateY(-2px);
    box-shadow: 0 6px 0 var(--color-primary-dark);

    /* ускоренный вход */
    transition: all 0.15s ease-out;
}

/* При нажатии */
.btn-form-submit:active,
.btn-form-submit-mobile:active {
    background: var(--color-primary);;
    transform: translateY(2px);
    box-shadow: 0 2px 0 var(--color-primary-dark);
    transition: all 0.1s ease-in;
}

.btn-form-submit {
    border-radius: 10px;
    padding: 11px 42px;
    /* width: 226px; */
    height: 59px;
    background: var(--color-primary);
    font-family: var(--font-family);
    font-weight: 500;
    font-size: var(--font-size-md);
    color: var(--color-white);
}

.btn-form-submit-mobile {
    border-radius: 10px;
    padding: 11px 42px;
    /* width: 360px; */
    height: 59px;
    background: var(--color-primary);
    font-family: var(--font-family);
    font-weight: 500;
    font-size: var(--font-size-md);
    color: var(--color-white);
}

.position-relative {
    position: relative;
}

.popup-enter-active,
.popup-leave-active {
    animation: fadeIn 0.3s ease-in-out, slideIn 0.3s ease-in-out;
}

.popup-leave-active {
    animation: fadeOut 0.3s ease-in-out, slideOut 0.3s ease-in-out;
}

.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}



.popup-container {
    background: #154734;
    padding: 20px;
    text-align: center;
    position: relative;
    border-radius: 30px;
    width: 594px;
    height: 421px;
}

.popup-close {
    position: absolute;
    top: 25px;
    right: 27px;
    background: none;
    border: none;
    color: #f2e4b5;
    cursor: pointer;
}

.popup-logo {
    width: auto;
    height: auto;
    margin-bottom: 38px;
    margin-top: 10px;
}

.popup-title {
    font-family: var(--font-family);
    font-weight: 700;
    font-size: 40px;
    text-transform: uppercase;
    text-align: center;
    color: #f2e4b5;
    margin-bottom: 31px;
}

.popup-text {
    font-family: var(--font-family);
    font-weight: 700;
    font-size: 36px;
    text-align: center;
    color: #f2e4b5;
    max-width: 346px;
    width: 100%;
    margin-bottom: 0px;
    line-height: 1.2;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes fadeOut {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

@keyframes slideIn {
    from {
        transform: translateY(-20px);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes slideOut {
    from {
        transform: translateY(0);
        opacity: 1;
    }

    to {
        transform: translateY(-20px);
        opacity: 0;
    }
}

.social-icons-container {
    cursor: pointer;
}

.social-icons-container svg {
    width: 48px;
    height: 48px;
    transition: transform 0.3s ease;
}

.social-icons-container svg:hover {
    transform: scale(1.1);
}

.social-icons-container {
    display: flex;
    flex-direction: row;
    gap: 20px;
    justify-content: center;
}

.j-logo-footer {
    width: 118px;
    height: 155px;
}

.politics-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 253px;
}

.main-container-footer {
    padding-left: clamp(16px, 10vw, 195.74px);
    padding-right: clamp(16px, 9.5vw, 184.11px);
    padding-top: clamp(40px, 6.76vh, 73px);
    padding-bottom: clamp(40px, 7.5vh, 101px);
    background-color: var(--color-primary);

}

.footer-j-logo {
    text-align: center;
}

.social-container {
    display: flex;
    flex-direction: column;
    /* gap: 20px; */
    /* flex-wrap: wrap; */
    justify-content: space-between;
    /* margin-top: auto; */

    height: 242px;
}

.footer-main-text {
    font-family: var(--font-family);;
    font-weight: 500;
    font-size: clamp(15px, 2.5vw, var(--font-size-lg));
    line-height: 175%;
    color: var(--color-white);
    margin-bottom: 0;
    text-decoration: none;
}

.link-text {
    font-family: var(--font-family);
    font-weight: 500;
    font-size: var(--font-size-lg);
    color: #FFFFFF;
    margin-bottom: 0px;
}

.footer-first-block {
    max-width: clamp(240px, 28.04vw, 476px);
    margin-right: clamp(20px, 3.13vw, 60px);
}

.footer-container {

    display: flex;
    justify-content: space-between;
    align-items: center;
}

.jameson-logo-footer {
    width: clamp(150px, 12.95vw, 228px);
    /* 268px ≈ 13.95vw на экране 1920px */
    height: clamp(130px, 5.93vh, 148px);
    /* 64px ≈ 5.93vh на экране 1080px */
}

.btn-green {
    border-radius: 10px;
    padding: 11px 42px;
    /* width: 226px; */
    height: 59px;
    background: #141097;
    font-family: var(--font-family);
    font-weight: 700;
    font-size: 20px;
    color: #f2e4b5;
}

.checkbox {
    /* appearance: none; */
    /* убираем стандартный стиль браузера */
    width: 20px;
    height: 20px;
    border: 1px solid var(--color-black);
    background-color: white;
    margin-right: 6px;
}

.checkbox-mobile {
    /* appearance: none; */
    /* убираем стандартный стиль браузера */
    width: 20px;
    height: 20px;
    border: 1px solid var(--color-black);
    background-color: white;
    margin-left: 20px;
}

.checkbox-container {
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    flex-direction: column;
}

.checkbox-container label {
    color: white;
    font-family: var(--font-family);
}

.checkbox-container router-link {
    color: white;
}

.btn-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.input-body {
    border: 1px solid #020202;
    color: var(--color-black);
    border-radius: 10px;
    padding: 15px 15px;
    width: 499px;
    height: 59px;
    font-size: var(--font-size-lg);
    font-family: var(--font-family);
    /* margin-left: auto; */
    /* Выравнивание поля ввода вправо */
}



.input-body::placeholder {
    color: var(--color-black);
    /* Задайте нужный цвет */
    font-size: 24px;
    font-family: var(--font-family);
    opacity: 1;
    /* Убедитесь, что текст полностью видим */
}

.input-name {
    font-family: var(--font-family);
    font-weight: 400;
    font-size: 24px;
    color: var(--color-black);
    margin-right: 20px;
    margin-bottom: 0px;
    /* Отступ между текстом и полем ввода */
    white-space: nowrap;
    /* Предотвращаем перенос текста */
}

.form-container {
    display: flex;
    align-items: baseline;
    width: 100%;
    /* Растягиваем контейнер */
}

.form-main {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 17px;
    /* расстояние между инпутами */
    max-width: 501px;
}

.text-title {
    font-family: var(--font-family);
    font-weight: 900;
    font-size: 40px;
    text-transform: uppercase;
    text-align: center;
    color: #141097;
    margin-bottom: 0;
    text-transform: uppercase;
    line-height: 1.2;
}

.title-container {
    /* width: 798px; */
    /* margin: auto; */
    padding-top: 86px;
    padding-bottom: 52px;
}

.registration-body-container {
    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    align-items: center;
    /* border-radius: 20px; */

    /* max-width: 1033px;
    min-width: 320px; */
    /* height: 100%; */

    /* background: #f2e4b5; */
    margin: auto;
}

.third-container {
    /* background-color: #F2E4B5; */
    position: relative;
    background-image: url('../assets/img/beefeater-form-bg.jpg');
    background-size: cover;
    background-position: center;
    /* height: 120vh; */
    /* padding: 142px 183.66px 127.15px 209.54px; */

}

.second-first-block {
    padding-top: 94px;
}

.number {
    color: var(--color-white);
    font-size: 96px;
    font-weight: 500;
    margin-bottom: 0px;
    font-family: var(--font-family);
}

.second-block-description span {
    color: var(--color-white);
    font-weight: 500;
    font-size: 32px;
    margin-bottom: 0px;
    display: flex;
    flex-direction: column;
    line-height: 1.2;
    text-transform: uppercase;
    font-family: var(--font-family);
}

.second-first-container {
    margin: 0px 183px 0px;
}

.second-block-title {
    color: var(--color-white);
    font-weight: 500;
    font-size: 96px;
    text-transform: uppercase;
    margin-bottom: 0px;
    font-family: var(--font-family);

}

.second-second-block {
    padding-bottom: 5.1979166667vw;
    max-width: 1075px;
}

.second-contaier {
    background-image:
        var(--bg-url);
    background-size: cover;
    background-position: center;
    height: 100%;
}

.big-img-first-block {
    max-width: 789.74px;
    max-height: 1046.18px;
    width: 100%;
    object-fit: cover;
    border-radius: 20px;
    /* transform: rotate(-7deg); */
}

.description-first-block {
    height: 275px;
    color: #141097;
    font-weight: 500;
    /* font-size: 30px; */
    font-size: 1.5625vw;
    line-height: 1.2;
    margin-top: 24px;
    /* max-width: 688px; */
    max-width: 780px;
    font-family: var(--font-family);
}

.description-first-block-small {
    font-weight: 500;
    font-size: 15px;
    color: #fff;
    line-height: 1.2;
    margin-top: 24px;
    max-width: 688px;
    font-family: var(--font-family);
}

.title-first-block span {
    text-transform: uppercase;
}

.title-first-block {
    color: var(--color-white);
    font-weight: 500;
    /* font-size: 40px; */
    font-size: 48px;
    line-height: 1.2;
    margin-top: 74.94px;
    font-family: var(--font-family);

}

.first-block {
    display: flex;
    flex-direction: column;
    padding: 100px 183.66px 127.15px 182px;

}

.jameson-invisible {
    width: 131px;
    height: 172px;
    margin-left: 54.04px;
}

.jameson-logo {
    width: 333px;
    height: 226px;
    margin-bottom: 18px;
}

.first-container {
    background-image: url('../assets/img/beefeater-first-block-bg.jpg');
    background-size: cover;
    background-position: center;
    /* height: 120vh; */
    /* padding: 86px 183.66px 127.15px 182px; */
    /* display: flex;
    justify-content: space-between;
    align-items: center; */
}

.snackbar-btn {
    color: var(--Red, #eb5757);
    font-family: var(--font-family);
    font-size: 0.875rem;
    font-weight: 400;
    letter-spacing: 0.0178571429em;
    line-height: 1.25rem;
    margin-right: auto;
    padding: 14px 16px;
    text-align: initial;
    cursor: pointer;
}



input:focus {
    outline: 1px solid #1976d2;
    /* синяя обводка */
    /* или */
    box-shadow: 0 0 5px #1976d2;
}

.header-text {
    font-family: var(--font-family);
    font-weight: 700;
    font-size: 24px;
    text-transform: uppercase;
    color: #FFFFFF;
}

.popup-close-1 {
    /* font-size: 20px; */
    cursor: pointer;
}

.popup-text-1 {
    font-family: var(--font-family);
    font-weight: 300;
    font-size: 24px;
    color: #FFFFFF;
    line-height: 1.6;
    white-space: pre-line;
    padding: 0 15px;
    overflow-y: auto;
    /* скролл только текста */
    flex: 1;
}

.popup-text-1::-webkit-scrollbar {
    width: 8px;
    /* толщина */
}

/* Ползунок */
.popup-text-1::-webkit-scrollbar-thumb {
    background-color: white;
    /* цвет (как на картинке) */
    border-radius: 10px;
    /* закругления */
}

/* Фон скроллбара */
.popup-text-1::-webkit-scrollbar-track {
    background: transparent;
    /* прозрачный трек */
}

.popup-close {
    margin-top: 10px;
    align-self: flex-end;
}

.custom-checkbox {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

/* стили для label */
.checkbox-label {
    /* display: flex;
  align-items: flex-start; */
    cursor: pointer;
    font-size: 20px;
    line-height: 1.3;
    font-family: var(--font-family);
    font-weight: 500;
    /* твой кастомный шрифт */
    position: relative;
    padding-left: 24px;
    /* отступ под квадратик */
}

/* кастомный квадратик */
.checkbox-label::before {
    content: "";
    position: absolute;
    left: -8px;
    top: 2px;
    width: 20px;
    height: 20px;
    border: 1px solid var(--color-black);
    border-radius: 2px;
    /* убери, если нужен квадрат без скруглений */
    background-color: #FFFFFF;
}

.checkbox-label::after {
    content: "";
    position: absolute;
    left: 0px;
    top: 5px;
    width: 6px;
    height: 10px;
    border: solid transparent;
    /* по умолчанию невидимая */
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    transition: border-color 0.2s ease;
}

/* при checked — черный фон и белая галочка */
.custom-checkbox:checked+.checkbox-label::before {
    background-color: var(--color-primary);
}

.custom-checkbox:checked+.checkbox-label::after {
    border-color: #FFFFFF;
    /* галочка белая */
}

/* ---------------------------------------MOBILE */

.third-container-mobile .city-select-container ::v-deep .v-select input::placeholder {
    font-size: var(--font-size-md) !important;
    /* нужный вам размер */
}

.third-container-mobile ::v-deep .v-select input::placeholder {
    white-space: normal !important;
    word-break: break-word;
}

.third-container-mobile ::v-deep .v-select.v-text-field:not(.v-text-field--single-line) input {
    margin-top: 0;
    text-align: left;
}

.third-container-mobile ::v-deep .v-text-field--outlined.v-input--dense.v-text-field--outlined>.v-input__control>.v-input__slot {
    /* min-height: 50px !important; */
}

.third-container-mobile ::v-deep .v-select input::placeholder {
    font-size: var(--font-size-md) !important;
    /* нужный вам размер */
}

.third-container-mobile ::v-deep .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot fieldset {
    color: var(--color-black) !important;
    border-radius: 6.64px;
}

.third-container-mobile ::v-deep .v-select.v-input--dense .v-select__selection--comma {
    margin: 0;
    font-size: 18px;
}

.third-container-mobile ::v-deep .v-input__slot {
    align-items: center;
    display: flex;
    margin-bottom: 8px;
    min-height: inherit;
    position: relative;
    transition: .3s cubic-bezier(.25, .8, .5, 1);
    transition-property: height, min-height;
    width: 461px;
}

.third-container-mobile ::v-deep .v-input {
    align-items: flex-start;
    display: flex;
    flex: none;
    font-size: 16px;
    letter-spacing: normal;
    max-width: 100%;
    text-align: left;
    height: 50px;
}

.third-container-mobile {
    /* background-image: url('../assets/img/absolut-form-bg-mobile.jpg');
    background-size: cover;
    background-position: right; */
    background-color: var(--color-white);
    position: relative;
    height: 100%;
    padding: 40px 0px 30.15px 0px;

}



.third-container-mobile ::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
    padding: 4px 3px;
    color: var(--color-black);
    font-size: var(--font-size-md);
    font-family: var(--font-family);
}

.third-container-mobile ::v-deep .v-select input::placeholder {
    color: var(--color-black) !important;
    font-weight: 500;
    font-size: var(--font-size-md);


}

.third-container-mobile ::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot {
    padding: 0 12px;
    min-width: 325px !important;
    width: 100% !important;
}

.third-container-mobile ::v-deep .v-list-item--dense .v-list-item__title {
    font-size: 18px !important;

}

.second-block-title-mobile {
    color: var(--color-white);
    font-weight: 500;
    font-size: var(--font-size-xl);
    text-transform: uppercase;
    margin-bottom: 12px;
    text-align: left;
    font-family: var(--font-family);
}

.second-block-description-mobile span {
    font-family: var(--font-family);
    color: #141097;
    font-weight: 700;
    font-size: 20px;
    display: flex;
    flex-direction: column;
    line-height: 28px;
    text-transform: uppercase;
    text-align: left;
}

.second-first-container-mobile {
    margin: 0px 30px 0px;
}

.number-mobile {
    color: var(--color-white);
    font-size:var(--font-size-xxl);
    font-weight: 500;
    margin-bottom: 0px;
    font-family: var(--font-family);
}

.condition-text-mobile {
    margin-bottom: 0px;
    display: flex;
    flex-direction: column;
    line-height: 1.1;
    margin-left: 39.4px;
    font-family: var(--font-family)
}

.condition-text-mobile span {
    font-weight: 500;
    font-size: var(--font-size-xs);
    color: var(--color-white);
    margin: 25px 0;
    font-family: var(--font-family);
}

.text-title-mobile {
    font-family: var(--font-family);
    font-weight: 900;
    font-size: 24px;
    text-transform: uppercase;
    text-align: center;
    color: #141097;
    margin-bottom: 0;
    line-height: 1.2;
    word-wrap: break-word;
}

.registration-body-container-mobile {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* border-radius: 20px; */
    padding: 0px 33.33px 0px;
    /* max-width: 1033px;
    min-width: 320px; */
    height: 100%;
    /* background: #f2e4b5; */
    margin: auto;
}

.footer-container-mobile {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
}

.no-truncate .v-select__selection {
    white-space: normal !important;
    text-overflow: initial !important;
    overflow: visible !important;
}


.first-block-logo-mobile {
    max-width: 320.11px;
    height: 47.02px;
    width: 100%;
    margin-bottom: 5.94px;
}

.first-container-mobile {
    background-image: url('../assets/img/bg-main-mobile.jpg');
    background-size: cover;
    background-position: bottom;
    /* height: 100vh; */
    padding: 0 30px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.second-first-block-mobile {
    padding-top: 32px;
}

.second-second-block-mobile {
    /* padding-bottom: 296px; */
}

.second-second-block-mobile .condition-container:nth-child(-n+3) {
    border-bottom: none;
    max-width: 520px;
}

.logo-container-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
}

.logo-container-footer-2 {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 46px;
}

.link-text-mobile {
    font-weight: 500;
    font-size: 15px;
    color: var(--color-white);
    margin-bottom: 0px;
    font-family: var(--font-family);
}

.politics-container-mobile {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.social-container-mobile {
    display: flex;
    flex-direction: column;
    /* gap: 20px; */
    /* flex-wrap: wrap; */
    justify-content: space-between;
    margin-top: 47px;
}

.main-container-footer-mobile {
    padding: 30px 15px;
    background-color: var(--color-primary);

}

.input-body-mobile {
    border: 1px solid var(--color-black);
    border-radius: 10px;
    padding: 15px 14px;
    min-width: 325px;
    width: 100%;
    height: 50px;
    font-size: var(--font-size-md);
    color: var(--color-black);
    font-family: var(--font-family);
    /* margin-left: auto; */
    font-weight: 500;
    /* Выравнивание поля ввода вправо */
}

.input-body-mobile::placeholder {
    color: var(--color-black);
    /* Задайте нужный цвет */
    font-size: var(--font-size-md);
    font-family: var(--font-family);
    opacity: 1;
    font-weight: 500;
    /* Убедитесь, что текст полностью видим */
}

.title-first-block-mobile {
    color: var(--color-white);
    font-weight: 500;
    font-size: 32px;
    line-height: 1.2;
    margin-top: 24.08px;
    font-family: var(--font-family);
    text-transform: uppercase;
    text-align: center;
}

.description-first-block-mobile {
    color: #141097;
    font-weight: 500;
    font-size: 18px;
    line-height: 1.2;
    margin-top: 24px;
    max-width: 360px;
    font-family: var(--font-family);
}

.description-first-block-small-mobile {
    font-weight: 500;
    font-size: 13px;
    color: #fff;
    line-height: 1.2;
    margin-bottom: 30px;
    max-width: 360px;
    font-family: var(--font-family);
}

.jameson-logo-mobile {
    width: 192.11px;
    height: 168.02px;
    /* margin-bottom: 18px; */
}

.big-img-first-block-mobile {
    max-width: 367.74px;
    /* max-height: 422.18px; */
    width: 100%;
    object-fit: cover;
    border-radius: 5px;
}

.third-container-mobile ::v-deep .v-select__selections {
    display: flex;
    /* оставляем flex */
    align-items: center;
    /* выравнивание по центру */
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    /* ... в конце */
}

.third-container-mobile ::v-deep .v-select__selections span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
    max-width: 100%;
}

/* .third-container-mobile ::v-deep .v-select.v-input {
  width: 100% !important;
  max-width: 325px; 
} */
.third-container-mobile ::v-deep .v-select input::placeholder {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    display: block;
    width: 100%;
}

.third-container-mobile ::v-deep .v-select input {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    width: 100% !important;
    display: block;
}

@media screen and (max-width: 1250px) {
    .checkbox-label {
        font-size: 16px;
    }

    /* кастомный квадратик */
    .checkbox-label::before {
        left: 0px;
        width: 15px;
        height: 15px;
    }

    .checkbox-label::after {
        left: 5px;
        top: 3px;
    }

    .checkbox-container label {
        color: black;
        text-align: left;
        font-size: 16px;
        font-weight: 500;
    }

    .third-container {
        padding: 35px 0 0;
    }

    .popup-close-1 {
        font-size: 16px;
    }

    .title-container {
        padding-bottom: 39px;
        padding-top: 0px;
    }

    .form-container {
        justify-content: center;
    }

    .checkbox-container label {
        color: white;
        text-align: left;
    }

    .input-body {
        text-align: left;
    }

    .input-body-mobile {
        text-align: left;
    }

    .footer-second-block {
         margin-top: 15px;
        text-align: center;
    }

    .footer-first-block {
        text-align: center;
        width: 100%;
        margin-right: 0px;
        max-width: 440px;
        margin-top: 30px;
    }

    .footer-main-text {
        padding: 5px 0;
    }

    .first-block {
        padding: 25px 0 0 0;
    }

    .popup-header {
        padding: 5px 0;
    }

    .header-text {
        font-family: var(--font-family);
        font-weight: 700;
        font-size: 16px;
        text-transform: uppercase;
        color: #FFFFFF;
    }

    /* Текст внутри */
    .popup-text-1 {
        font-family: var(--font-family);
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 1.6;
        white-space: pre-line;
        padding: 0;
        overflow-y: auto;
        /* скролл только текста */
        flex: 1;
    }

    .popup-close-1 {
        font-size: 16px;
    }
}

@media screen and (max-width: 566px) {
    /* .checkbox-label::before {
        margin-top: 10px;
    } */

    .checkbox-label::after {
        left: 5px;
        /* top: 13px; */
    }
}

@media (max-width: 1617px) and (min-width: 1250px) {
    .first-block {
        display: flex;
        flex-direction: column;
        padding: 86px 120.66px 127.15px 120px;
    }

    .title-first-block {
        color: var(--color-white);
        font-weight: 900;
        /* font-size: 40px; */
        font-size: 2.5333333333vw;
        line-height: 1.2;
        margin-top: 74.94px;
        font-family: var(--font-family);
        max-width: 730px;
    }

    .description-first-block {
        max-width: 590px;
    }

    .second-first-container {
        margin: 0 120px;
    }
}



@media screen and (max-width: 376px) {
    .form-container[data-v-a608fcba] {
        max-width: 228px;
    }

    .additional {
        padding: 30px 20px 0px 30px;
    }

    .error-message {
        font-size: 12px;
    }

    .input-body-mobile {
        min-width: 100%;
    }

    .addition-height {
        height: 50px;
    }

    .third-container-mobile ::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot {
        max-width: 228px !important;
        min-width: 100% !important;
    }

    .input-body-mobile {
        max-width: 228px !important;
        min-width: 100% !important;
    }

    /* .first-block {
        padding: 15px;
    } */

}

@media screen and (orientation: landscape) {
    .second-contaier-mobile {
        background-image: url('../assets/img/second-block-bg.jpg');
        background-size: cover;
        background-position: center;
        /* height: 100vh; */
    }


}
</style>

<script>
import { mapGetters } from "vuex";
import { mask } from "vue-the-mask";
import Otp from '@/components/otp.vue';
import ConfirmAge1 from "@/components/age-confirm.vue";
import config from "@/config/pageConfig.json";
export default {

    directives: { mask },
    name: "SocialLead",
    components: {
        Otp,
        ConfirmAge1
    },
    data() {
        return {
            showConfirm: true,
            isMobile: window.innerWidth < 1264,
            phone: '',
            items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
            checkbox: false,
            email: '',
            name: '',
            city: '',
            instagram: '',
            product: '',
            surname: '',
            showOtpPopup: false,
            snackbar: false,
            message: "",
            otp: '',
            expectedOtp: '1111',
            loading: false,
            smsTimer: 60, // 60 секунд
            smsTimerInterval: null,
            isSendSms: false,
            isPopupOpen: false,
            currentPopup: null,
            showPopup: false,
            formSchema: null,
            otpSuccess: false,
            otpVerifying: false,
            isLoadingForm: true,
            formError: false,
            otpError: "",
            otpErrorSms: false,
            formData: {},
            errors: {},
            touched: {},
            popupTexts: {
                policy: {
                    title: "Политика конфиденциальности",
                    content: `<b>Pernod Ricard Kazakhstan,</b> в качестве оператора персональных данных, уважает ваше
                право на конфиденциальность при использовании веб-сайта
                Цель настоящей Политики конфиденциальности — информировать вас о том, каким
                образом компания Pernod Ricard Kazakhstan собирает, хранит, использует и обрабатывает
                ваши персональные данные, предоставленные через веб-сайт (далее «Веб-сайт»).
                Темы:
                1. Какие персональные данные мы собираем?
                2. Как и зачем мы используем технологии отслеживания?
                3. С какой целью мы используем ваши персональные данные и на каком правовом
                основании?
                4. Что произойдет, если вы откажетесь предоставить свои персональные данные?
                5. Кому мы раскрываем ваши персональные данные и почему?
                6. Передаются ли ваши персональные данные за пределы Казахстана?
                7. Как долго мы храним ваши персональные данные?
                8. Как мы обеспечиваем защиту ваших персональных данных?
                9. Каковы ваши права в отношении ваших персональных данных?
                10. Как с нами связаться или подать жалобу в надзорный орган?
                11. Изменения в Политике конфиденциальности

                <b>1. Какие персональные данные мы собираем?</b>
                Мы собираем следующие персональные данные:
                -  Имя, фамилия
                - Дата рождения
                - Адрес электронной почты
                - Пароль
                - Должность
                - Название места работы
                - Фотография
                - IP-адрес
                - Интересы
                <b>Примечание:</b> IP-адрес — это последовательность чисел, используемая для
                идентификации вашего устройства при каждом подключении к интернету.

                <b>2. Как и зачем мы используем технологии отслеживания?</b>
                С вашего согласия, если это требуется по закону, наш Веб-сайт использует файлы cookie и
                подобные технологии отслеживания, такие как IP-адреса или журналы. Эти технологии
                помогают нам:
                - Лучше понимать, как посетители используют наш Веб-сайт и его функции.
                - Улучшать их функциональность.
                - Предоставлять контент, соответствующий вашим интересам.
                
                <b>Подробнее о cookies:</b> см. Политику использования файлов cookie.

                <b>3. С какой целью мы используем ваши персональные данные и на каком</b>
                правовом основании?
                <b>Pernod Ricard Kazakhstan</b> обрабатывает ваши данные в следующих целях:
                - Предоставление доступа к Веб-сайту и создание профиля пользователя.
                - Обеспечение доступа к функциям сайта (например, доступ к онлайн-контенту,
                участие в тренингах, регистрация на мероприятия).
                - Отправка административных уведомлений и сервисных сообщений.
                Мы также можем адаптировать наш контент в зависимости от ваших интересов для
                улучшения вашего опыта на сайте.
                При наличии вашего согласия данные могут использоваться для отправки маркетинговых
                сообщений.

                <b>4. Что произойдет, если вы откажетесь предоставить свои персональные
                данные?</b>
                Если вы решите не предоставлять запрашиваемые данные, вы не сможете:
                - Участвовать в некоторых активностях.
                - Пользоваться персонализированными функциями.
                - Получать специальные услуги.
                <b>Пример:</b> без адреса электронной почты вы не сможете получать наши рассылки. Однако
                вы можете просматривать сайт без предоставления данных.

                <b>5. Кому мы раскрываем ваши персональные данные и почему?</b>
                <b>В рамках группы Pernod Ricard</b>
                Ваши данные могут быть переданы аффилированным компаниям группы Pernod Ricard.
                <b>Третьи стороны</b>
                Ваши данные могут быть переданы третьим сторонам в следующих случаях:
                - <b>Техническая поддержка:</b> провайдеры, агенты или подрядчики.
                - <b>Организация мероприятий и тренингов.</b>
                - <b>По закону:</b> для защиты прав и безопасности компании или общества.
                - <b>Слияние или поглощение:</b> передача данных новому владельцу в соответствии с
                законом.

                <b>6. Передаются ли ваши персональные данные за пределы Казахстана?</b>
                Данные могут передаваться за границу с соблюдением всех необходимых мер защиты,
                включая стандартные договорные положения Европейской комиссии.

                <b>7. Как долго мы храним ваши персональные данные?</b>
                Данные хранятся:
                - Пока ваш аккаунт активен.
                - Пока это необходимо для предоставления функций сайта.
                Также данные могут храниться для выполнения правовых обязательств.

                <b>8. Как мы обеспечиваем защиту ваших персональных данных?</b>
                <b>Pernod Ricard Kazakhstan</b> принимает все необходимые меры для защиты ваших данных,
                включая:
                > Хранение данных в защищенных операционных средах.
                - Доступ к данным только у уполномоченных сотрудников и подрядчиков.

                <b>9. Каковы ваши права в отношении ваших персональных данных?</b>
                Вы имеете право:
                - Отозвать согласие на обработку данных.
                - Запросить доступ, исправление или удаление данных.
                - Ограничить обработку или запросить перенос данных.
                - Возражать против обработки.

                <b>10. Как с нами связаться или подать жалобу в надзорный орган?</b>
                По вопросам и жалобам, связанным с Политикой конфиденциальности, обращайтесь по
                адресу:
                <b>Алматы, Казахстан, Рубинштейна, 48, 050060</b>

                Или по электронной почте: <b>promo.kz@pernod-ricard.com.</b>

                <b>11. Изменения в Политике конфиденциальности</b>
                Мы регулярно обновляем нашу Политику конфиденциальности и размещаем изменения
                на этой странице.
                <b>Дата последнего обновления:</b> ноябрь 2024 года.`,
                },
                offer: {
                    title: "СОГЛАСИЕ НА СБОР И ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ (для клиентов и потенциальных клиентов)",
                    content: `Я подтверждаю, что достиг возраста 21 года и более и даю <b>ТОО «Перно Рикар
                Казахстан», (БИН 050840001045),</b> а также их работникам и третьим лицам-соисполнителям по
                заключенным между ними договорам, <b>свое согласие</b> на сбор, обработку,
                распространение и трансграничную передачу (без дополнительных уведомлений)
                моих персональных данных, относящихся исключительно к перечисленным ниже
                категориям персональных данных:
                 1) ФИО
                 2) Город проживания
                 3) Мобильный телефон
                 4) E-mail
                <b>Согласованная цель сбора и обработки персональных данных</b> – пополнение CRM
                базы посредством предоставления персональных данных любыми средствами связи
                для участия в активностях, проводимых в отношении товарных знаков продукции
                ТОО «Перно Рикар Казахстан».
                Я даю согласие на использование персональных данных исключительно в
                вышеуказанных целях, а также на обработку персональных данных и их
                трансграничную передачу на всех электронных носителях, используемых для
                вышеуказанной цели.
                Настоящее согласие предоставляется мной на осуществление действий в отношении
                моих персональных данных, которые необходимы для достижения указанных выше
                целей, включая (без ограничения) сбор, систематизацию, накопление, хранение,
                уточнение (обновление, изменение), использование, передачу третьим лицам для
                осуществления действий по обмену информацией, обезличивание, блокирование
                персональных данных, трансграничную передачу персональных данных на территорию любого государства, в том числе не обеспечивающего защиту персональных данных, распространение моих персональных данных в общедоступных источниках,
                а также осуществление любых иных действий,
                предусмотренных действующим законодательством Республики Казахстан.
                Я предоставляю согласие на контактирование со мной для вышеуказанных целей путем осуществления разговора, телефонных звонков, направления мне уведомлений с использованием почты, телефона (также SMS), социальных сетей и/или мессенджеров, вебсайтов, электронной почты, электронных информационных ресурсов и иных информационных систем и мобильных приложений. 
                Я проинформирован, что вышеуказанные компании гарантируют обработку моих
                персональных данных в соответствии с действующим законодательством Республики
                Казахстан как неавтоматизированным, так и автоматизированным способами.
                Данное согласие действует в течение срока хранения информации в вышеуказанных
                целях.
                Данное согласие может быть отозвано в любой момент по моему письменному заявлению, отправленному в адрес Компании по ее юридическому адресу, зарегистрированному на дату отправки заявления или посредством направления электронного сообщения на электронную почту Компании: promo.kz@pernod-ricard.com. В случае отзыва настоящего согласия все мои Персональные данные подлежат уничтожению из базы данных Компании. 
Я подтверждаю, что для включения моих персональных данных в базу данных, в том числе партнеров указанных компаний, передачи, распространения, дополнения и прочей обработки моих персональных данных указанными компаниями с вышеупомянутой целью не требуется дополнительного уведомления меня о совершении данных действий. 

Я подтверждаю, что, давая настоящее согласие, я действую по собственной воле, в своих интересах и полностью осознаю суть и цели подписываемого документа. `,
                },
                rules: {
                    title: "Полные правила активности",
                    content: `               <b>1. Общие положения </b>

                    1.1. Активация не является лотереей, азартной игрой или иным мероприятием,
                    регулируемым Законом Республики Казахстан от 9 апреля 2016 года № 495-V «О лотереях
                    и лотерейной деятельности».
                    1.2. Период проведения Активации: с 29 августа 2025 года по 15 сентября 2025 года
                    (включительно).
                    1.3. Участие в активации является добровольным и означает полное и безусловное
                    согласие участника с настоящими Правилами.
                    1.4. Пул предоставляемых возможностей формируется за счёт средств Организатора.

                                               <b> 2. Условия участия </b>

                    2.1. К участию допускаются только физические лица, достигшие 21 года на момент
                    участия, постоянно проживающие на территории Республики Казахстан, не являющиеся
                    сотрудниками Организатора, а также сотрудниками подрядных организаций, причастных к
                    проведению активации, и их близкими родственниками.
                    2.2. Принимая участие в активации, участник подтверждает, что настоящие Правила им
                    прочитаны и понятны, и что участник безоговорочно и в полном объеме соглашается с
                    ними, без каких-либо ограничений и исключений.
                    2.3. Для участия участнику необходимо:
                    2.3.1. подписаться на официальный аккаунт @Chivas_kz в социальной сети Instagram;
                    2.3.2. пройти регистрацию на официальном сайте Организатора.
                    2.4. Один пользователь Instagram может участвовать только единожды, с одного личного
                    аккаунта.
                    2.4. Все условия должны быть выполнены участником в период, указанный в п. 1.2.
                    настоящих Правил.

                    <b>3. Пул предоставляемых единиц</b>

                    3.1. В пул включены следующие поощрения:
                    3.1.1. посещение пре-пати зоны от Chivas Regal на концерте Backstreet Boys, который
                    состоится 19 сентября 2025 года на Центральном стадионе г.Алматы (далее -
                    Мероприятие).
                    3.1.2. посещение VIP-фан-зону на концерте Backstreet Boys, который состоится 19
                    сентября 2025 года на Центральном стадионе г.Алматы.
                    3.2. Пул предоставляемых единиц не подлежит обмену на денежный эквивалент или
                    замене.

                    <b>4. Порядок определения участника, получающего доступ к мероприятию</b>

                    4.1. По завершении периода проведения Активации Организатор в случайном порядке
                    определяет одного участника, который получает возможность посетить пре-пати зоны от
                    Chivas Regal и одного участника с возможность посещения на двоих VIP-фан-зоны
                    Мероприятия.
                    4.2. Участник будет уведомлен Организатором через личное сообщение в Instagram с
                    официального аккаунта @Chivas_kz в течение 3 (трёх) рабочих дней после завершения
                    периода проведения активации.
                    4.3. В случае отсутствия ответа участника в течение 48 часов с момента отправки ему
                    уведомления Организатор вправе самостоятельно определить другого участника.

                    <b>5. Ограничения и ответственность</b>

                    5.1. Организатор не несёт ответственности за невозможность участия в Активации или
                    получения участником доступа к Мероприятию по причинам, не зависящим от
                    Организатора, в том числе:
                    - сбои в работе Instagram, сайта или интернет-провайдера;
                    - блокировка или удаление аккаунта участника или Организатора;

                    -предоставление участником недостоверных данных;
                    5.2. Организатор оставляет за собой право отказать в учёте участия или аннулировать
                    результат при выявлении фактов нарушения участником настоящих Правил или
                    использования недобросовестных методов участия.
                    5.3. Организатор не несёт ответственности за отмену Мероприятия или перенос даты
                    проведения Мероприятия, указанного в п. 3.1, а также за изменение формата или условий
                    Мероприятия, вызванные обстоятельствами, не зависящими от него.

                    <b>6. Форс-мажор</b>

                    6.1. Организатор освобождается от ответственности за частичное или полное
                    невыполнение обязательств, если это явилось следствием обстоятельств непреодолимой
                    силы (форс-мажора), включая: природные катастрофы, пожары, военные действия,
                    массовые беспорядки, забастовки, ограничения со стороны госорганов, эпидемии,
                    перебои в электроснабжении или сбои в работе сетей связи, а также иные обстоятельства,
                    находящиеся вне разумного контроля Организатора.
                    6.2. В случае наступления и действия обстоятельств непреодолимой силы Организатор
                    вправе приостановить, продлить или прекратить проведение активации без
                    предварительного уведомления участников.

                    <b>7. Персональные данные</b>

                    7.1. Участвуя в Активации, участник подтверждает согласие на сбор, обработку, хранение
                    и передачу, в том числе трансграничную передачу собственных персональных данных
                    (имя, фамилия, контактные данные, данные аккаунта в Instagram) в целях проведения
                    Активации.
                    7.2. Сбор, обработка, хранение и передача данных осуществляется в соответствии с
                    законодательством Республики Казахстан и политикой конфиденциальности
                    Организатора.

                    <b>8. Заключительные положения</b>

                    7.1. Организатор вправе изменять условия и сроки проведения активации, публикуя
                    обновлённую информацию на официальных ресурсах.
                    7.2. Все спорные вопросы, связанные с проведением активации, разрешаются в
                    соответствии с законодательством Республики Казахстан.
                    7.3. В случаях, не урегулированных настоящими Правилами, толкование и решение
                    Организатора является окончательным и обязательным для всех участников.
                    7.4. Факт участия в активации означает ознакомление и полное согласие участника с
                    настоящими Правилами.
                    7.5. Ответственность Организатора перед участниками ограничена исключительно
                    организацией данной активацией и формированием пула поощрительных единиц.
                    7.6. Принятием участия в активации, участник подтверждает, что действует лично, от
                    своего имени, добровольно и самостоятельно, принимает на себя все риски
                    ответственности и последствий, связанных с возможным участием в активации и
                    получением поощрений.`,
                }
            },
            config: {
                ...config,

                // bgLogoMainMobile: require(`@/assets/img/${config.bgLogoMainMobile}`),
                // bgLogoMain: require(`@/assets/img/${config.bgLogoMain}`),
                // logoMain: require(`@/assets/img/${config.logoMain}`),
                // logoMainMobile: require(`@/assets/img/${config.logoMainMobile}`),
                // logoInvisible: require(`@/assets/img/${config.logoInvisible}`),
                // bigImage: require(`@/assets/img/${config.bigImage}`),
                // bigImageMobile: require(`@/assets/img/${config.bigImageMobile}`),
                // footer: {
                //     ...config.footer,
                //     logoMainFooter: require(`@/assets/img/${config.footer.logoMainFooter}`),
                //     logoMainMobileFooter: require(`@/assets/img/${config.footer.logoMainMobileFooter}`),
                //     logo: require(`@/assets/img/${config.footer.logo}`),
                //     // Если есть другие картинки в футере — добавь их сюда
                // }
            }
        };
    },
    created() {
        if (localStorage.getItem("userAge") !== null) {
            this.showConfirm = false
        }
    },
    computed: {
        ...mapGetters(['getUserAge']),
        filteredQuestions() {
            if (!this.formSchema?.questions) return [];
            return this.formSchema.questions.filter(q => (q.type === 11 || q.type === 12));
        },
        normalQuestions() {
            if (!this.formSchema?.questions) return [];
            return this.formSchema.questions.filter(q => (q.type !== 11 && q.type !== 3 && q.type !== 12));
        }

    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        console.log('Возраст пользователя:', this.getUserAge);
        this.getFormFields();
        // Здесь можно использовать this.getUserAge.day, .month, .year
    },
    watch: {
        formData: {
            deep: true,
            handler(val) {
                for (let [id, value] of Object.entries(val)) {
                    this.validateField(id, value);
                }
            }
        },
        getUserAge(newVal) {
            if (!newVal || !this.formSchema) return;

            const birthQuestion = this.formSchema.questions.find(q => q.type === 3);
            if (birthQuestion) {
                this.$set(this.formData, birthQuestion.id, newVal);
                console.log("NEW DATA");
            }
        }
    },
    methods: {
        onConfirmed() {
            this.showConfirm = false
            console.log("Компонент закрыт")
            // localStorage.setItem("ageConfirmed", "1")
        },
        handleResize() {
            this.isMobile = window.innerWidth < 1264;
        },
        //     onFinish (rsp) {
        //     this.loading = true
        //     setTimeout(() => {
        //       this.loading = false
        //       this.snackbarColor = (rsp === this.expectedOtp) ? 'success' : 'warning'

        //     }, 3500)
        //   },
        validateField(question) {
            const value = this.formData[question.id];
            let error = null;

            // Проверка только для текстовых полей (например id 1,2,7,4)
            if ([1, 2, 4, 7].includes(question.type)) {
                if (!value || value.trim() === "") {
                    error = "Поле обязательно";
                }
            }
            if ([11].includes(question.type)) {
                if (!value && this.touched[question.id]) {
                    error = "Вы должны принять условия.";
                }
            }
            if ([12].includes(question.type)) {
                if (!value && this.touched[question.id]) {
                    error = "Вы должны принять условия.";
                }
            }
            if (error === null) {
                if ([1].includes(question.type)) {
                    // Имя только буквы
                    if (!/^[А-Яа-яA-Za-z\s]+$/.test(value)) {
                        error = "Введите корректное имя.";
                    }
                }

                if ([2].includes(question.type)) {
                    // Фамилия только буквы
                    if (!/^[А-Яа-яA-Za-z\s]+$/.test(value)) {
                        error = "Введите корректную фамилию.";
                    }
                }

                if ([7].includes(question.type)) {
                    // Email
                    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
                        error = "Введите корректный email.";
                    }
                }

                if ([4].includes(question.type)) {
                    // Телефон
                    if (!/^\+7\(\d{3}\) \d{3}-\d{2}-\d{2}$/.test(value)) {
                        error = "Введите корректный номер телефона.";
                    }
                }
            }

            this.$set(this.errors, question.id, error);
        },
        markTouched(question) {
            this.$set(this.touched, question.id, true);
            this.validateField(question);
        },
        getPlaceholder(question) {
            switch (question.type) {
                case 5:
                    return "Город";
                case 9:
                    return "Какой Absolut вы предпочитаете?";
                case 10:
                    return "Введите логин";
                default:
                    return question.name;
            }
        },
        getFormFields() {
            this.isLoadingForm = true;
            this.formError = false;
            this.$http.get('/api/survey', {
                params: {
                    campaignId: "e7cf1cb4-a4dc-f011-b7ff-00155d79212a"
                }
            })
                .then(res => {
                    this.formSchema = res.data;
                    res.data.questions.forEach(q => {
                        if (q.type === 3) {
                            this.$set(this.formData, q.id, this.getUserAge);
                        } else {
                            this.$set(this.formData, q.id, "");
                        }
                    });
                })
                .catch(err => {
                    this.formError = true;
                    console.error("Ошибка загрузки формы", err);
                })
                .finally(() => {
                    this.isLoadingForm = false;
                });
        },
        submitForm() {
            console.log("Отправка формы:", this.formData);
            // пример отправки
            // this.$http.post("/api/survey/submit", this.formData)
        },
        openPopup(type) {
            this.currentPopup = type
            this.isPopupOpen = true
        },
        goTo(url) {
            window.open(url, '_blank'); // Откроется в новой вкладке
        },
        logCity() {
            console.log(this.city);
        },
        logNumber() {
            console.log(this.phone);
        },
        async sendVerificationCode() {
            const phoneQuestion = this.formSchema.questions.find(q => q.type === 4);
            if (!phoneQuestion) return;

            const phoneAnswerRaw = this.formData[phoneQuestion.id];
            const phoneAnswer = phoneAnswerRaw.replace(/[^\d+]/g, "");
            // Готовим DTO
            const answerDto = {
                campaignId: "e7cf1cb4-a4dc-f011-b7ff-00155d79212a",
                surveyAnswer: {
                    surveyQuestionId: phoneQuestion.id,
                    answer: phoneAnswer
                }
            };

            try {
                await this.$http.post("/api/Verification/SendCode", answerDto);
                console.log("Код отправлен!");
                this.otpErrorSms = false;
            } catch (err) {
                console.error("Ошибка при отправке кода:", err);
                 if (err?.response?.status === 409) {
                    // пользователь уже зарегистрирован
                  // this.formData = {};
                    this.otpErrorSms = true;
                    this.showOtpPopup = true;
                    this.otpSuccess = false // открываем попап
                    return; // прерываем выполнение
                }
            }
        },
        async resendSms() {
            // можно просто вызвать sendVerificationCode ещё раз
            await this.startSmsTimer();
            await this.sendVerificationCode();
        },
        async confirmRegistration() {
            // Проверка на заполненность всех полей
            this.otpError = "";
            if (!this.formSchema) return;
            console.log(this.formData);
            const hasEmptyField = Object.keys(this.formData).some(key => {
                const value = this.formData[key];
                console.log(this.formData);
                const type = this.formSchema.questions.find(q => q.id === this.formData[key])?.type; // допустим, вопросы в массиве

                if (type === 11 || type === 12) {
                    // чекбокс — false = ошибка
                    return value === false;
                }

                // для остальных — пустые значения
                return value === null || value === undefined || value === '';
                // return value === null || value === undefined || value === '' || value === false;
            });

            // Проверка: есть ли ошибки валидации
            const hasErrors = Object.values(this.errors).some(error => error && error.length > 0);
            console.log("Erors", this.errors);
            if (hasEmptyField || hasErrors) {
                this.snackbar = true;
                this.message = hasErrors
                    ? 'Исправьте ошибки в форме перед отправкой'
                    : 'Пожалуйста, заполните все поля';
                return;
            }
            try {
                console.log(this.formData);
                this.isSendSms = true;
                await this.sendVerificationCode();
                if (!this.otpErrorSms) {  // 👈 только если не было 409
                    this.otpError = "";
                    this.otpSuccess = false;
                    this.showOtpPopup = true;
                    this.startSmsTimer();
                }
            } catch {
                this.snackbar = true;
                this.message = 'Ошибка при отправке кода. Попробуйте снова.';
            }
            finally {
            this.isSendSms = false;
            }
        },
        async submitAnswersWithCode(code) {
            this.otpVerifying = true;
            this.otpError = "";
            this.otpSuccess = false;
            try {
                const payload = {
                    surveyId: this.formSchema.id,
                    campaignId: "e7cf1cb4-a4dc-f011-b7ff-00155d79212a",
                    verificationCode: code,
                    answers: Object.entries(this.formData).map(([key, value]) => {
                        let answer = String(value);

                        if (/^\+7[\d\s()-]{10,}$/.test(answer)) {
                            answer = answer.replace(/[^\d+]/g, '');
                        }

                        return {
                            surveyQuestionId: key,
                            answer
                        };
                    })
                };

                await this.$http.post('/api/AnswerSet', payload);
                this.otpSuccess = true;
                this.formData = {};
                // this.showOtpPopup = false; // закрыть попап
            } catch (error) {
                console.error(error);
                const msg = error?.response?.data?.message || "Код введён неверно";
                this.otpError = msg;
            } finally {
                this.otpVerifying = false;
            }
        },
        async startSmsTimer() {
            this.smsTimer = 60;
            if (this.smsTimerInterval) clearInterval(this.smsTimerInterval);
            this.smsTimerInterval = setInterval(() => {
                if (this.smsTimer > 0) {
                    this.smsTimer--;
                } else {
                    clearInterval(this.smsTimerInterval);
                    this.smsTimerInterval = null;
                    // Здесь можно вызвать метод компонента otp через $refs, если нужно
                }
            }, 1000);
        },
        onPhoneFocus(question) {
            if (!this.formData[question.id]) {
                this.$set(this.formData, question.id, '+7');
            }
        },
        onPhoneInput(question) {
            const val = this.formData[question.id] || '';
            if (!val.startsWith('+7')) {
                this.formData[question.id] = '+7' + val.replace(/\D/g, '').slice(1);
            }
            this.validateField(question);
        },
        closePopup() {
            this.showPopup = false;
            this.isPopupOpen = false; // Закрыть pop-up
            // Очистка полей
            this.phone = '';
            this.email = '';
            this.name = '';
            this.city = '';
            this.surname = '';
            this.checkbox = false;
        },
    }
}


</script>